import { UserEntityInterface } from '@types';
import { PagePermission, PermissionActions } from '@enums';

export const userHasPagePermission = (
  currentUser: UserEntityInterface,
  permissionPages: PagePermission[],
  permissionActions: PermissionActions[]
): boolean => {
  const roles = currentUser?.roles?.length ? currentUser?.roles : currentUser?.unit?.roles;
  return roles?.some((role) =>
    role?.pagePermissions?.some(
      (page) =>
        permissionPages.includes(page.name) && permissionActions.some((action) => page[action])
    )
  );
};
